import CustomersList from './CustomersList';
import './CustomersList.scss';

export default CustomersList;
